import { BasilLayoutGrid } from "@/components/icons/basil";
import { cn } from "@shared/lib/utils";
import { HOME_AGENTS } from "@/lib/homeAgents";
import { AgentAvatar } from "./AgentAvatar";

type AssistantFilterChipsProps = {
  /** Selected agentId, or null for "All". */
  selected: string | null;
  onSelect: (agentId: string | null) => void;
};

const CHIP_BASE =
  "flex min-h-11 shrink-0 items-center gap-2 rounded-full border px-3.5 py-1.5 font-mono text-[11px] font-medium uppercase tracking-[0.08em] transition-colors duration-200";
/** Active chip mirrors the draw FocusPicker — accent hairline, no glow. */
const CHIP_ACTIVE = "border-accent/60 bg-accent/10 text-ink";
const CHIP_IDLE = "border-line bg-white/4 text-ink-mute hover:border-line-hi hover:text-ink";

/** Horizontal assistant filter — "All" + the six assistants, scrollable on mobile. */
export function AssistantFilterChips({ selected, onSelect }: AssistantFilterChipsProps) {
  return (
    <div
      aria-label="Filter by assistant"
      className="flex gap-2 overflow-x-auto pb-1 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
    >
      <button
        type="button"
        aria-pressed={selected === null}
        onClick={() => onSelect(null)}
        className={cn(CHIP_BASE, selected === null ? CHIP_ACTIVE : CHIP_IDLE)}
      >
        <BasilLayoutGrid className="size-3.5 shrink-0" aria-hidden />
        All
      </button>

      {HOME_AGENTS.map((agent) => (
        <button
          key={agent.agentId}
          type="button"
          aria-pressed={selected === agent.agentId}
          onClick={() => onSelect(agent.agentId)}
          className={cn(CHIP_BASE, selected === agent.agentId ? CHIP_ACTIVE : CHIP_IDLE)}
        >
          <span className="size-5 shrink-0 overflow-hidden rounded-full border border-line">
            <AgentAvatar agent={agent} className="size-full" />
          </span>
          {agent.name}
        </button>
      ))}
    </div>
  );
}
